import { active } from "@api/stores/measurementUnits/active/path";
import { deactive } from "@api/stores/measurementUnits/deactive/path";
import { stats } from "@api/stores/measurementUnits/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/measurement-units/`;
const pathById = `${pathBase}:measurementUnitId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const measurementUnits = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  stats,
};
